import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client, { endpoints } from '../api/client';

export default function Admin() {
  const [summary, setSummary] = useState(null);
  const [activity, setActivity] = useState([]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const load = async () => {
    try {
      const [s, a] = await Promise.all([
        client.get(endpoints.analytics.summary),
        client.get(endpoints.analytics.activity, { params: { limit: 20 } }),
      ]);
      setSummary(s.data);
      setActivity(a.data.items);
    } catch (e) {
      setMsg(e.response?.data?.error || e.message);
    }
  };
  useEffect(() => { load(); }, []);

  const seed = async () => {
    setBusy(true); setMsg('');
    try {
      const { data } = await client.post(endpoints.admin.seed);
      setMsg(data.seeded ? `Seeded ${data.count} memberships.` : `Already seeded.`);
      load();
    } catch (e) { setMsg(e.response?.data?.error || e.message); }
    setBusy(false);
  };

  return (
    <section className="section">
      <h1>Admin</h1>

      <div className="card">
        <h2>Quick navigation</h2>
        <ul className="link-list">
          <li><Link to="/admin/users">→ Users</Link></li>
          <li><Link to="/admin/invites">→ Invites</Link></li>
          <li><Link to="/admin/roles">→ Roles &amp; permissions</Link></li>
          <li><Link to="/account/api-keys">→ Your API keys</Link></li>
          <li><Link to="/docs">→ Module documentation</Link></li>
        </ul>
      </div>

      {summary && (
        <div className="card">
          <h2>Last 30 days</h2>
          <div className="stat-row">
            <div className="stat"><div className="stat-num">{summary.inventory.total}</div><div className="stat-label">Total inventory</div></div>
            <div className="stat"><div className="stat-num">{summary.inventory.available}</div><div className="stat-label">Available</div></div>
            <div className="stat"><div className="stat-num">{summary.leads.new}</div><div className="stat-label">New leads</div></div>
            <div className="stat"><div className="stat-num">{summary.leads.converted}</div><div className="stat-label">Converted</div></div>
            <div className="stat"><div className="stat-num">{summary.signups}</div><div className="stat-label">New signups</div></div>
          </div>
        </div>
      )}

      <div className="card">
        <h2>Demo data</h2>
        <button className="btn-primary" onClick={seed} disabled={busy}>{busy ? 'Seeding…' : 'Seed demo inventory'}</button>
        {msg && <p className="status">{msg}</p>}
      </div>

      <div className="card">
        <h2>Recent activity</h2>
        <table className="data-table">
          <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Target</th></tr></thead>
          <tbody>
            {activity.length === 0 && <tr><td colSpan="4" className="muted">No activity yet.</td></tr>}
            {activity.map(a => (
              <tr key={a._id}>
                <td>{new Date(a.createdAt).toLocaleString()}</td>
                <td>{a.actor?.email || '—'}</td>
                <td>{a.action}</td>
                <td>{a.target} {a.targetId ? `#${String(a.targetId).slice(-6)}` : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
